import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

const customTheme = {
  dark: false,
  colors: {
    primary: '#1D1D1F',
    secondary: '#86868B',
    accent: '#0071E3',
    error: '#FF3B30',
    info: '#0071E3',
    success: '#34C759',
    warning: '#FF9500',
    background: '#FFFFFF',
    surface: '#FFFFFF',
  }
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'customTheme',
    themes: {
      customTheme,
    }
  },
  defaults: {
    VBtn: {
      rounded: 'pill',
      elevation: 0,
    },
    VCard: {
      elevation: 0,
    },
    VTextField: {
      variant: 'outlined',
      rounded: 'lg',
      color: '#1D1D1F',
    },
    VTextarea: {
      variant: 'outlined',
      rounded: 'lg',
      color: '#1D1D1F',
    },
    VSelect: {
      variant: 'outlined',
      rounded: 'lg',
      color: '#1D1D1F',
    },
  }
})
